var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vx-tooltip',{staticClass:"svglight inline-block relative",staticStyle:{"top":"0.2rem","margin-left":"0.1rem"},attrs:{"text":_vm.text}},[_c('small',{staticClass:"flex cursor-pointer"},[_c('feather-icon',{attrs:{"icon":"HelpCircleIcon","svgClasses":"w-4 h-4 text-light"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }